export default __webpack_public_path__ + "static/media/windows.0e18f701.svg";